import { IActionOptions } from '@interfaces/IActionOptions';
import { IEvent } from '@interfaces/IEvent';
import { IFormErrors } from '@interfaces/IFormsErrors';
import { IStudentWorksQParams } from '@interfaces/IQParams';
import { IStudentWork } from '@interfaces/IStudentWork';
import { IStudentWorkReview } from '@interfaces/IStudentWorkReview';
import { IStudentWorksStats } from '@interfaces/IStudentWorksStats';
import { Action } from '@ngrx/store';
import { IReviewTemplates } from '@interfaces/IReviewTemplates';

export enum EStudentWorksActions {
  AddStudentWork = '[Student Works] Add',
  AddStudentWorkSuccess = '[Student Works] Add Success',
  AddStudentWorkFailure = '[Student Works] Add Failure',
  ClearAddStudentWorkErrors = '[Student Works] Clear Student Work Errors',

  UpdateStudentWork = '[Student Works] Update',
  UpdateStudentWorkSuccess = '[Student Works] Update Success',

  GetStudentWorks = '[Student Works] Get All',
  GetStudentWorksSuccess = '[Student Works] Get All Success',
  GetStudentWorksFailure = '[Student Works] Get All Failure',
  ClearStudentWorks = '[Student Works] Clear Student Works',

  GetStudentWorksStats = '[Student Works] Get Stats',
  GetStudentWorksStatsSuccess = '[Student Works] Get Stats Success',
  GetStudentAllWorksStatsSuccess = '[Student Works] Get All Stats Success',
  GetStudentWorksStatsFailure = '[Student Works] Get Stats Failure',
  ClearStudentAllWorksStats = '[Student Works] Clear All Stats',

  GetReviewTemplatesRequest = '[Student Works] Get all templates Request',
  GetReviewTemplatesSuccess = '[Student Works] Get all templates Success',
  GetReviewTemplatesFailure = '[Student Works] Get all templates Failure',

  AddReviewTemplateRequest = '[Student Works] Add all template Request',
  AddReviewTemplateSuccess = '[Student Works] Add all template Success',
  AddReviewTemplateFailure = '[Student Works] Add all template Failure',

  AddWorksReview = '[Student Works]  Add Works Review',
  AddWorksReviewSuccess = '[Student Works] Add Works ReviewSuccess',
  AddWorksReviewFailure = '[Student Works] Add Works Review Failure',

  GetWorkReview = '[Student Works] Get Work Review',
  GetWorkReviewSuccess = '[Student Works] Get Work Review Success',
  GetWorkReviewFailure = '[Student Works] Get Work Review Failure',

  EditWorkReview = '[Student Works] Edit Work Review',
  EditWorkReviewSuccess = '[Student Works] Edit Work Review Success',
  EditWorkReviewFailure = '[Student Works] Edit Work Review Failure',

  PublishReviews = '[Student Works]  Publish Reviews',
  PublishReviewsSuccess = '[Student Works]  Publish Reviews Success',
  PublishReviewsFailure = '[Student Works]  Publish Reviews Failure',

  DownloadWorks = '[Student Works]  Download',
  DownloadWorksSuccess = '[Student Works] Download Success',
  DownloadWorksFailure = '[Student Works] Download Failure',

  DownloadAllWorks = '[Student Works]  DownloadAll',

  TakeInCheckStudentWorksRequest = '[Student works] Take In Check Student Works Request',
  TakeInCheckStudentWorksSuccess = '[Student works] Take In Check Student Works Success',
  TakeInCheckStudentWorksFailure = '[Student works] Take In Check Student Works Failure',

  TransferReviewersRequest = '[Transfer] Transfer Reviewers Request',
  TransferReviewersSuccess = '[Transfer] Transfer Reviewers Success',
  TransferReviewersFailure = '[Transfer] Transfer Reviewers Failure',

  AutoAssignRequest = '[Student works] Auto Assign Request',
  AutoAssignSuccess = '[Student works] Auto Assign Success',
  AutoAssignFailure = '[Student works] Auto Assign Failure',
  ClearAutoAssignErrors = '[Student works] Clear Auto Assign Errors',
}

export class AddStudentWork implements Action {
  public readonly type = EStudentWorksActions.AddStudentWork;

  constructor(public work: FormData) {}
}

export class UpdateStudentWork implements Action {
  public readonly type = EStudentWorksActions.UpdateStudentWork;

  constructor(public work: FormData, public id: number) {}
}

export class UpdateStudentWorkSuccess implements Action {
  public readonly type = EStudentWorksActions.UpdateStudentWorkSuccess;
}

export class AddStudentWorkSuccess implements Action {
  public readonly type = EStudentWorksActions.AddStudentWorkSuccess;
}

export class AddStudentWorkFailure implements Action {
  public readonly type = EStudentWorksActions.AddStudentWorkFailure;

  constructor(public errors: { [key: string]: string[] }) {}
}

export class ClearAddStudentWorkErrors implements Action {
  public readonly type = EStudentWorksActions.ClearAddStudentWorkErrors;
}

export class GetStudentsWorks implements Action {
  public readonly type = EStudentWorksActions.GetStudentWorks;

  constructor(public queries?: { [key: string]: string }) {}
}

export class GetStudentsWorksSuccess implements Action {
  public readonly type = EStudentWorksActions.GetStudentWorksSuccess;

  constructor(
    public payload: {
      results: IStudentWork[];
      count: number;
      challenge_count: number;
      urgent_homeworks_count: number;
    }
  ) {}
}

export class GetStudentsWorksStats implements Action {
  public readonly type = EStudentWorksActions.GetStudentWorksStats;

  constructor(public qParams?: { [key: string]: string }) {}
}

export class GetStudentWorksStatsSuccess implements Action {
  public readonly type = EStudentWorksActions.GetStudentWorksStatsSuccess;

  constructor(public stats: IStudentWorksStats) {}
}

export class GetStudentAllWorksStatsSuccess implements Action {
  public readonly type = EStudentWorksActions.GetStudentAllWorksStatsSuccess;

  constructor(public stats: IStudentWorksStats) {}
}

export class GetStudentWorksStatsFailure implements Action {
  public readonly type = EStudentWorksActions.GetStudentWorksStatsFailure;
}

export class ClearStudentAllWorksStats implements Action {
  public readonly type = EStudentWorksActions.ClearStudentAllWorksStats;
}

export class GetStudentsWorksFailure implements Action {
  public readonly type = EStudentWorksActions.GetStudentWorksFailure;
}

export class ClearStudentWorks implements Action {
  public readonly type = EStudentWorksActions.ClearStudentWorks;
}

export class AddWorksReview implements Action {
  public readonly type = EStudentWorksActions.AddWorksReview;

  constructor(public works: number[], public options?: IActionOptions) {}
}

export class AddWorksReviewSuccess implements Action {
  public readonly type = EStudentWorksActions.AddWorksReviewSuccess;
}

export class AddWorksReviewFailure implements Action {
  public readonly type = EStudentWorksActions.AddWorksReviewFailure;
}

export class GetWorkReview implements Action {
  public readonly type = EStudentWorksActions.GetWorkReview;

  constructor(public id: number) {}
}

export class GetWorkReviewSuccess implements Action {
  public readonly type = EStudentWorksActions.GetWorkReviewSuccess;

  constructor(public review: IStudentWorkReview) {}
}

export class GetWorkReviewFailure implements Action {
  public readonly type = EStudentWorksActions.GetWorkReviewFailure;
}

export class EditWorkReview implements Action {
  public readonly type = EStudentWorksActions.EditWorkReview;

  constructor(
    public review: {
      id: number;
      text?: string;
      points?: string;
      is_published?: boolean;
      reviewer_id?: number;
      is_copied?: boolean;
    },
    public replaceState?: boolean
  ) {}
}

export class EditWorkReviewSuccess implements Action {
  public readonly type = EStudentWorksActions.EditWorkReviewSuccess;

  constructor(public review?: IStudentWorkReview) {}
}

export class EditWorkReviewFailure implements Action {
  public readonly type = EStudentWorksActions.EditWorkReviewFailure;
}

export class PublishReviews implements Action {
  public readonly type = EStudentWorksActions.PublishReviews;

  constructor(
    public reviews: number[],
    public scheduled_datetime?: string,
    public options?: IActionOptions
  ) {}
}

export class PublishReviewsSuccess implements Action {
  public readonly type = EStudentWorksActions.PublishReviewsSuccess;

  constructor(public reviews: { id: number; is_published: boolean }[]) {}
}

export class PublishReviewsFailure implements Action {
  public readonly type = EStudentWorksActions.PublishReviewsFailure;
}

export class DownloadWorks implements Action {
  public readonly type = EStudentWorksActions.DownloadWorks;

  constructor(public works: number[]) {}
}

export class DownloadAllWorks implements Action {
  public readonly type = EStudentWorksActions.DownloadAllWorks;

  constructor(public queries?: { [key: string]: string }) {}
}

export class DownloadWorksSuccess implements Action {
  public readonly type = EStudentWorksActions.DownloadWorksSuccess;
}

export class DownloadWorksFailure implements Action {
  public readonly type = EStudentWorksActions.DownloadWorksFailure;
}

export class TakeInCheckStudentWorksRequest implements Action {
  public readonly type = EStudentWorksActions.TakeInCheckStudentWorksRequest;

  constructor(
    public qParams: IStudentWorksQParams,
    public options?: IActionOptions
  ) {}
}

export class TakeInCheckStudentWorksSuccess implements Action {
  public readonly type = EStudentWorksActions.TakeInCheckStudentWorksSuccess;
}

export class TakeInCheckStudentWorksFailure implements Action {
  public readonly type = EStudentWorksActions.TakeInCheckStudentWorksFailure;
}

export class AutoAssignStudentWorksRequest implements Action {
  public readonly type = EStudentWorksActions.AutoAssignRequest;

  constructor(
    public payload: {
      event: IEvent;
      reviewer_ids?: number[];
    }
  ) {}
}

export class AutoAssignStudentWorksSuccess implements Action {
  public readonly type = EStudentWorksActions.AutoAssignSuccess;
}

export class AutoAssignStudentWorksFailure implements Action {
  public readonly type = EStudentWorksActions.AutoAssignFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearAutoAssignStudentWorksErrors implements Action {
  public readonly type = EStudentWorksActions.ClearAutoAssignErrors;
}

export class GetTemplatesRequest implements Action {
  public readonly type = EStudentWorksActions.GetReviewTemplatesRequest;
}
export class GetTemplatesSuccess implements Action {
  public readonly type = EStudentWorksActions.GetReviewTemplatesSuccess;
  constructor(public templates: IReviewTemplates[]) {}
}
export class GetTemplatesFailure implements Action {
  public readonly type = EStudentWorksActions.GetReviewTemplatesFailure;
  constructor(public errors: IFormErrors) {}
}

export class TransferReviewersRequest implements Action {
  public readonly type = EStudentWorksActions.TransferReviewersRequest;

  constructor(public reviewers: number[], public toUser: number) {}
}

export class TransferReviewersSuccess implements Action {
  public readonly type = EStudentWorksActions.TransferReviewersSuccess;
}

export class TransferReviewersFailure implements Action {
  public readonly type = EStudentWorksActions.TransferReviewersFailure;

  constructor(public error: IFormErrors) {}
}

export class AddTemplateRequest implements Action {
  public readonly type = EStudentWorksActions.AddReviewTemplateRequest;
  constructor(public payload: { id: number; template_id: number }) {}
}
export class AddTemplateSuccess implements Action {
  public readonly type = EStudentWorksActions.AddReviewTemplateSuccess;
}
export class AddTemplateFailure implements Action {
  public readonly type = EStudentWorksActions.AddReviewTemplateFailure;
  constructor(public errors: IFormErrors) {}
}

export type StudentWorksActions =
  | AddStudentWork
  | AddStudentWorkSuccess
  | AddStudentWorkFailure
  | GetStudentsWorks
  | GetStudentsWorksSuccess
  | GetStudentsWorksFailure
  | ClearStudentWorks
  | GetStudentsWorksStats
  | GetStudentWorksStatsSuccess
  | GetStudentAllWorksStatsSuccess
  | GetStudentWorksStatsFailure
  | ClearStudentAllWorksStats
  | AddWorksReviewFailure
  | UpdateStudentWorkSuccess
  | AddWorksReview
  | AddWorksReviewSuccess
  | GetWorkReviewFailure
  | GetWorkReview
  | GetWorkReviewSuccess
  | EditWorkReview
  | EditWorkReviewSuccess
  | EditWorkReviewFailure
  | PublishReviewsSuccess
  | PublishReviewsFailure
  | PublishReviews
  | DownloadWorks
  | DownloadAllWorks
  | DownloadWorksSuccess
  | DownloadWorksFailure
  | UpdateStudentWork
  | ClearAddStudentWorkErrors
  | TakeInCheckStudentWorksRequest
  | TakeInCheckStudentWorksSuccess
  | TakeInCheckStudentWorksFailure
  | AutoAssignStudentWorksRequest
  | AutoAssignStudentWorksSuccess
  | AutoAssignStudentWorksFailure
  | ClearAutoAssignStudentWorksErrors
  | GetTemplatesRequest
  | GetTemplatesSuccess
  | GetTemplatesFailure
  | AddTemplateRequest
  | AddTemplateSuccess
  | AddTemplateFailure
  | TransferReviewersRequest
  | TransferReviewersSuccess
  | TransferReviewersFailure;
